// extracted by mini-css-extract-plugin
module.exports = {"editor":"match-profile-editor_editor__1phcC","horizontal":"match-profile-editor_horizontal__27xDq"};